<template>
  <div
    class="info-tile"
    :class="{
      pointer: isClickable,
    }"
  >
    <div class="d-flex align-items-center justify-content-between mb-3">
      <span class="top-text">
        {{ topText }}
      </span>
      <i class="fal fa-arrow-right c-brand-color" v-if="isClickable"></i>
    </div>
    <div>
      <slot>
        <span class="data mr-1">{{ data }}</span>
        <span class="unit">{{ unit }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'HMInfoTile.vue',
  props: {
    topText: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    isClickable() {
      return this.$listeners?.click;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.info-tile {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid $medium-gray;
  border-radius: 6px;
  overflow: auto;
  padding: 1rem;
}
.top-text {
  font-size: $h5-font-size;
  font-weight: $font-weight-normal;
  color: $dark-gray;
}
.data {
  font-size: $h4-font-size;
  font-weight: $font-weight-bold;
  color: $charcoal;
}
.unit {
  font-size: $h4-font-size;
  color: $dark-gray;
}
</style>
